import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  function randomNumber(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  function createRandomSVG() {
    const isDesktop = window.innerWidth > 768

    const hearts = []
    const svgSettings = {
      totalIcons: isDesktop ? 20 : 15,
      maxScale: isDesktop ? 8 : 6,
    }

    for (let i = 0; i < svgSettings.totalIcons; i++) {
      hearts.push(
        <div
          key={'svg-heart-' + i}
          className="svg-box"
          style={{
            left: randomNumber(0, 100) + '%',
            top: randomNumber(0, 100) + '%',
            transform:
              'scale(' +
              randomNumber(2, svgSettings.maxScale) +
              ') rotateZ(' +
              randomNumber(-30, 30) +
              'deg)',
            fill: 'rgba(255, 50, 50, ' + randomNumber(1, 6) / 10 + ')',
            animation: 'show-hide ' + randomNumber(20, 50) / 10 + 's infinite',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M12 4.419c-2.826-5.695-11.999-4.064-11.999 3.27 0 7.27 9.903 10.938 11.999 15.311 2.096-4.373 12-8.041 12-15.311 0-7.327-9.17-8.972-12-3.27z" />
          </svg>
        </div>
      )
    }
    return hearts
  }

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro18">
      <div className="intro18">
        <div className="animation-container">
          {typeof background !== 'undefined' && background && (
            <img
              src={background}
              className="animation-container__custom-image"
            />
          )}
          <div className="couple-container">
            <div className="pulse-container"></div>
            <h1 className="couple-container__names notranslate">
              {coupleSingleName.bride}
              {!!coupleSingleName.groom && (
                <Fragment>
                  <span> &</span> {coupleSingleName.groom}
                </Fragment>
              )}
            </h1>
            <div className="svg-container">{createRandomSVG()}</div>
          </div>

          <div className="bottom">
            <button className="button" type="button" onClick={onSkipIntro}>
              {buttonMessage}
            </button>
            <p
              className="warning"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
